module.exports = __webpack_public_path__ + "static/media/visual.8bd0e1ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/visual.jpg
// module id = 643
// module chunks = 0